import { render, staticRenderFns } from "./upload-list.vue?vue&type=template&id=64666648&"
import script from "./upload-list.vue?vue&type=script&lang=js&"
export * from "./upload-list.vue?vue&type=script&lang=js&"
import style0 from "./upload-list.vue?vue&type=style&index=0&id=64666648&prod&lang=scss&scopped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports